type TrackingProps = {
  event?: string
  location?: string
  component?: string
  linkUrl?: string
  text?: string
  tileName?: string
  context?: any
  affiliateId?: number
  userRole?: string
  groupId?: number
  bannerName?: string
  bannerCategory?: string
  bannerLocation?: string
  dataId?: string
  parent?: string
  link?: string
}

export const trackEvent = ({
  component,
  event,
  location,
  linkUrl,
  text,
  tileName,
  context,
  affiliateId,
  userRole,
  groupId,
  bannerName,
  bannerCategory,
  bannerLocation,
  dataId,
  parent,
  link,
}: TrackingProps) => {
  analytics.track(
    event,
    decamelizeKeys({
      event,
      location,
      ...(component && component !== '' && { component }),
      ...(linkUrl && linkUrl !== '' && { link_url: linkUrl }),
      ...(text && text !== '' && { text }),
      ...(tileName && tileName !== '' && { tile_name: tileName }),
      ...(affiliateId && { affiliateId }),
      ...(userRole && { userRole }),
      ...(groupId && { groupId }),
      ...(bannerName && { bannerName }),
      ...(bannerCategory && { bannerCategory }),
      ...(bannerLocation && { bannerLocation }),
      ...(dataId && { dataId }),
      ...(parent && { parent }),
      ...(link && { link }),
    }),
    { context },
  )
}

import { decamelizeKeys } from 'humps'
import type { ButtonEvent } from 'services/segment/types'
import { getPageHeight, formatAsPercent } from 'services/segment/utilities'

export const trackButtonEvent = (props: ButtonEvent) => {
  const {
    eventType,
    component,
    appliedComponent,
    pageUrl,
    buttonText,
    buttonColor,
    buttonStyle,
    buttonId,
    yPosition,
    linkUrl,
  } = props

  /* TODO: Add page vertical as category, and button variant */
  const trackingProps = {
    component: component,
    location: appliedComponent,
    linkUrl,
    pageUrl: pageUrl ?? location.href,
    buttonText,
    buttonColor,
    buttonStyle,
    buttonId,
    pagetitle: document.title,
    ...(yPosition !== undefined && {
      yPosition:
        document.body.getBoundingClientRect().top + window.scrollY - yPosition,
      downThePage: formatAsPercent(
        document.body.getBoundingClientRect().top + window.scrollY - yPosition,
      ),
      pageHeight: getPageHeight(),
    }),
  }

  analytics.track(`${component} ${eventType}`, trackingProps)
}
